/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

import {conversationParams} from '../../modules/conversation/conversationParams';
import {conversationEvent} from '../../modules/event/conversationEvent';

export const getConversationEventsParams = conversationParams;

export type GetConversationEventsParams = z.infer<typeof getConversationEventsParams>;

export const getConversationEventsResponse = z.array(conversationEvent);

export type GetConversationEventsResponse = z.infer<typeof getConversationEventsResponse>;
